module.exports = {"130129100":"赞皇镇","130129101":"院头镇","130129200":"西龙门乡","130129201":"南邢郭乡","130129202":"南清河乡","130129203":"西阳泽乡","130129204":"土门乡","130129205":"黄北坪乡","130129206":"嶂石岩乡","130129207":"许亭乡","130129208":"张楞乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130129.json
// module id = 71
// module chunks = 0